import { AttioConnection, SettingCardViewAction } from '@monetize/types/app';
import { FC, useState } from 'react';
import { MFlex, MText } from '../../../../../../components/Monetize';
import { SettingCardView } from '../../../../../../components/Settings/SettingCardView';
import { CrmConnectionHealth } from '../../useCrmConnectionHealth';
import { CrmConnectionHealthAlert } from '../CrmConnectionHealthAlert';
import { QuoteStatusToDealStageMapping } from './QuoteStatusToDealStageMapping';

interface AttioCrmConnectionProps {
  connection: AttioConnection;
  health: CrmConnectionHealth;
  reAuthorize: () => void;
  verifyConnection: () => Promise<void>;
}

export const AttioCrmConnection: FC<AttioCrmConnectionProps> = ({
  connection,
  health,
  reAuthorize,
  verifyConnection,
}) => {
  const [mode, setMode] = useState<'VIEW' | 'EDIT'>('VIEW');

  const handleAction = async (action: SettingCardViewAction) => {
    switch (action) {
      case 'RE_AUTHENTICATE':
        reAuthorize();
        break;
      case 'VERIFY':
        await verifyConnection();
        break;
      case 'DELETE':
        break; // TODO: BE not implemented

      default:
        break;
    }
  };

  return (
    <>
      <CrmConnectionHealthAlert
        crmLabel="Attio"
        health={health}
        onReAuthenticate={reAuthorize}
      />
      {mode === 'VIEW' && (
        <SettingCardView
          omitEditButton
          status={health.status === 'unhealthy' ? 'ERROR' : 'ACTIVE'}
          actions={[
            { action: 'RE_AUTHENTICATE', label: 'Re-Authenticate' },
            { action: 'VERIFY', label: 'Verify Connection' },
            // { // TODO: not yet implemented on BE
            //   action: 'DELETE',
            //   label: 'Delete',
            //   isDanger: true,
            //   confirmProps: {
            //     title: `Are you sure you want to delete this connection?`,
            //     message: `You will lose all your data and configurations related to this connection.`,
            //   },
            // },
          ]}
          onAction={handleAction}
          onEdit={() => setMode('EDIT')}
          type="Attio"
          tags={[
            {
              label: 'Workspace ID',
              value: connection.workspaceId,
            },
            {
              label: 'Workspace Name',
              value: connection.workspaceName,
            },
            {
              label: 'Authorized Member ID',
              value: connection.authorizedMemberId,
            },
          ]}
        />
      )}

      <MFlex direction="column" gap={4}>
        <MFlex color="tPurple.dark" direction="inherit" gap={2}>
          <MText fontWeight="semibold">Attio Data Mapping</MText>
        </MFlex>
        <MText>
          There are some Attio data points that are equivalent to MonetizeNow
          data points. You can map the data from Attio to MonetizeNow for
          accurate importing.
        </MText>
        <QuoteStatusToDealStageMapping
          existingMappings={connection.quoteStatusToDealStageMappings}
        />
      </MFlex>
    </>
  );
};
